import React from 'react';

import { Center, Stack, Text } from '@mantine/core';
import { IconCalendarSearch } from '@tabler/icons-react';

interface IEmptyEventPlaceholder {
  activeTab: string;
}

const EmptyEventPlaceholder = ({ activeTab }: IEmptyEventPlaceholder): JSX.Element => {
  const activeTabInPlural = activeTab === 'class' ? 'classes' : 'appointments';
  return (
    <Stack color='dimmed'>
      <Text weight={600} size={21} color='dimmed'>
        No {activeTabInPlural} scheduled for this day
      </Text>

      <Center p='xl' mt={100}>
        <IconCalendarSearch color='#999999' size={124} />
      </Center>
    </Stack>
  );
};

export default EmptyEventPlaceholder;
